import { patientNamespace } from "@/store/modules/patient";
import _ from "lodash";
import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";

interface TowerItem {
  id: string;
  option: string;
  seq: number;
  singleEntryOnly: number;
}
const ENTER_COMMENT = "enter comment";

@Component({})
export default class ChoiceList extends Vue {
  @Prop()
  choices!: Array<string>;

  @Prop()
  selected!: string;

  @Emit()
  updateSelected() {
    if (this.isRadio) {
      if (this.radioGroup) {
        return `${this.radioGroup.id}.${this.radioGroup.seq}`;
      }
    } else {
      return this.checkboxGroup
        .map(checkbox => `${checkbox.id}.${checkbox.seq}`)
        .join(",");
    }
  }
  @Emit()
  commentRequired() {
    if (this.isRadio && this.radioGroup) {
      return this.radioGroup.option.includes(ENTER_COMMENT);
    } else {
      return this.checkboxGroup
        .map(checkbox => checkbox.option)
        .some(option => option.includes(ENTER_COMMENT));
    }
  }

  @Getter("towerChoices", patientNamespace)
  towerChoices!: Record<string, Array<TowerItem>>;
  radioGroup: TowerItem | null = null;
  checkboxGroup: Array<TowerItem> = [];

  get selectedValues(): Array<string> {
    if (this.selected) {
      return this.selected.split(",");
    } else {
      return [];
    }
  }

  mounted() {
    const selectedChoices = this.combinedChoices.filter(choice =>
      this.selectedValues.includes(`${choice.id}.${choice.seq}`)
    );
    if (this.isRadio) {
      this.radioGroup = selectedChoices[0];
    } else {
      this.checkboxGroup = selectedChoices;
    }
  }

  get isRadio() {
    return this.combinedChoices.every(i => i.singleEntryOnly === 1);
  }

  get combinedChoices() {
    const combined: Array<TowerItem> = [];
    this.choices.forEach(choice =>
      combined.splice(combined.length, 0, ...this.towerChoices[choice])
    );
    return combined;
  }

  get singleItems() {
    return this.combinedChoices.filter(choice => choice.singleEntryOnly);
  }

  checkboxChecked(checkItem: TowerItem) {
    // Clear others if this is singleEntryOnly
    if (checkItem.singleEntryOnly === 1 && this.checkboxGroup.includes(checkItem)) {
      this.checkboxGroup = [checkItem];
    } else if (checkItem.singleEntryOnly === 0) {
      // Uncheck any singles that were selected
      _.remove(this.checkboxGroup, { singleEntryOnly: 1 });
    }
  }

  @Watch("checkboxGroup")
  @Watch("radioGroup")
  changeMade() {
    this.updateSelected();
    this.commentRequired();
  }

  clearRadio() {
    this.radioGroup = null;
  }
}
